import { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import save from 'save-file'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export const CaptionDropdown = ({
  srtFunction,
  vttFunction,
  srtWordFunction,
  filename,
}) => {
  return (
    <Menu as="div" className="relative w-[fit-content] text-left">
      <div>
        <Menu.Button className="inline-flex w-full items-center justify-center gap-x-1.5 rounded-md px-3 py-2 text-xs text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
          Captions
          <ChevronDownIcon
            className="-mr-1 mt-0.5 h-5 w-5 text-xs text-gray-400"
            aria-hidden="true"
          />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute bottom-full right-0 z-10 mb-2 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="cursor-pointer py-1">
            <Menu.Item>
              {({ active }) => (
                <span
                  onClick={async () => {
                    const transcriptToSave = await srtFunction()
                    save(transcriptToSave, `${filename}.srt`)
                  }}
                  className={classNames(
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                    'block px-4 py-2 text-sm'
                  )}
                >
                  SRT (Sentences)
                </span>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <span
                  onClick={async () => {
                    const transcriptToSave = await srtWordFunction()
                    save(transcriptToSave, `${filename}.srt`)
                  }}
                  className={classNames(
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                    'block px-4 py-2 text-sm'
                  )}
                >
                  SRT (Word by Word)
                </span>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <span
                  onClick={async () => {
                    const transcriptToSave = await vttFunction()
                    save(transcriptToSave, `${filename}.vtt`)
                  }}
                  className={classNames(
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                    'block px-4 py-2 text-sm'
                  )}
                >
                  VTT Captions
                </span>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
